import { render, staticRenderFns } from "./AddInTickListBtn.vue?vue&type=template&id=5c3d11d1"
import script from "./AddInTickListBtn.vue?vue&type=script&lang=js"
export * from "./AddInTickListBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports